import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bienvenido/a de nuevo, ${user.name}`);
      navigate(user.is_admin ? "/admin" : "/");
    } catch (err) {
      setError(err.response?.data?.detail || "No se pudo iniciar sesión. Verifica tus datos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-md flex-col px-4 py-14 sm:py-20">
      <div className="mb-8 text-center">
        <img src="/brand/logo-gradient.png" alt="Tu Iglesia App" className="mx-auto h-20 w-auto" />
        <h1 className="mt-4 font-serif text-3xl font-semibold">Bienvenido/a de nuevo</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Entra para comentar, guardar mensajes y publicar peticiones de oración.
        </p>
      </div>
      <Card className="border-border bg-card shadow-[var(--shadow-sm)]">
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="email">Correo electrónico</Label>
              <Input
                id="email"
                type="email"
                required
                maxLength={254}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@correo.com"
                data-testid="auth-login-email-input"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="password">Contraseña</Label>
              <Input
                id="password"
                type="password"
                required
                maxLength={128}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                data-testid="auth-login-password-input"
              />
            </div>
            {error && (
              <p className="text-sm text-destructive" data-testid="auth-login-error">{error}</p>
            )}
            <Button type="submit" disabled={loading} data-testid="auth-login-submit-button">
              {loading ? "Entrando…" : "Iniciar sesión"}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-muted-foreground">
            ¿No tienes cuenta?{" "}
            <Link to="/registro" className="font-semibold text-primary hover:text-primary/80" data-testid="auth-go-register-link">
              Crea una aquí
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
